import React, { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { MessageCircleIcon } from 'lucide-react';
import { CartDrawer } from './components/CartDrawer';
import { CartProvider } from './components/CartContext';
import { Nav } from './components/Nav';
import { Cursor } from './components/Cursor';
import { Footer } from './components/Footer';
import { IntroPreloader } from './components/IntroPreloader';
import { Home } from './pages/Home';
import { Envios } from './pages/Envios';
import { Faq } from './pages/Faq';
import { Privacidad } from './pages/Privacidad';
function ScrollToHash() {
  const {
    hash
  } = useLocation();
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (hash) {
      setTimeout(() => {
        const target = document.querySelector(hash);
        if (target) {
          const nav = document.getElementById('nav');
          const offset = (nav?.offsetHeight ?? 0) + 24;
          window.scrollTo({
            top: (target as HTMLElement).offsetTop - offset,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  }, [hash]);
  return null;
}
function ScrollToTopOnLoad() {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    if (window.location.hash) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    const toTop = () => window.scrollTo(0, 0);
    toTop();
    requestAnimationFrame(toTop);
    const t1 = window.setTimeout(toTop, 60);
    const t2 = window.setTimeout(toTop, 250);
    return () => {
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, []);
  return null;
}
export function App() {
  return <BrowserRouter data-id="element-0">
      <CartProvider data-id="element-1">
        <ScrollToTopOnLoad data-id="element-2" />
        <ScrollToHash data-id="element-3" />
        <IntroPreloader data-id="element-4" />
        <div className="w-full" data-id="element-5">
          <Cursor data-id="element-6" />
          <Nav data-id="element-7" />
          <Routes data-id="element-8">
            <Route path="/" element={<Home data-id="element-10" />} data-id="element-9" />
            <Route path="/pages/envios-devoluciones" element={<Envios data-id="element-12" />} data-id="element-11" />
            <Route path="/pages/preguntas-frecuentes" element={<Faq data-id="element-14" />} data-id="element-13" />
            <Route path="/pages/politica-de-privacidad" element={<Privacidad data-id="element-16" />} data-id="element-15" />
          </Routes>
          <Footer data-id="element-17" />
          <CartDrawer data-id="element-18" />
          <a href="https://wa.me/573213396782?text=Hola%20SAVIA%2C%20me%20interesa%20conocer%20m%C3%A1s%20sobre%20sus%20velas." className="wa-float" target="_blank" rel="noopener noreferrer" aria-label="Escríbenos por WhatsApp" data-id="element-19">
            <MessageCircleIcon size={18} strokeWidth={1.5} data-id="element-20" />
            <span className="wa-float__text" data-id="element-21">Escríbenos</span>
          </a>
        </div>
      </CartProvider>
    </BrowserRouter>;
}